export const DOMAIN_COLORS = {
  Audio: '#5DCAA5',
  Video: '#85B7EB',
  Linguistics: '#AFA9EC',
  Visual: '#F0997B',
  Music: '#ED93B1',
  'Computer Use': '#85B7EB',
  'Data Science': '#E8A87C',
  'AI Evaluation': '#95C4B5',
};

// Theme-aware domain colors — use in CSS `color` property (not backgrounds with opacity)
export const DOMAIN_COLORS_CSS = {
  Audio: 'var(--accent-teal)',
  Video: '#85B7EB',
  Linguistics: '#AFA9EC',
  Visual: '#F0997B',
  Music: '#ED93B1',
  'Computer Use': '#85B7EB',
  'Data Science': '#E8A87C',
  'AI Evaluation': '#95C4B5',
};

// RGB values for domain colors — use in rgba() for backgrounds
export const DOMAIN_COLORS_RGB = {
  Audio: 'var(--accent-teal-rgb)',
  Video: '133, 183, 235',
  Linguistics: '175, 169, 236',
  Visual: '240, 153, 123',
  Music: '237, 147, 177',
  'Computer Use': '133, 183, 235',
  'Data Science': '232, 168, 124',
  'AI Evaluation': '149, 196, 181',
};

export const currentUserId = 1;

export const users = [
  {
    id: 1,
    name: 'Maya Chen',
    domain: 'Audio',
    badge: 'Verified Audio Specialist',
    isFacilitator: true,
    quality: 97.3,
    jobs: 24,
    initials: 'MC',
    streak: 8,
    bio: 'Sound designer with 8 years in film post-production. Specializing in Foley, ambient soundscapes, and environmental audio annotation. Previously at Skywalker Sound.',
    linkedin: 'https://linkedin.com/in/mayachen',
    website: 'https://mayachen.audio',
    availability: 'Active',
    qualityHistory: [94.1, 95.2, 96.0, 95.8, 96.5, 97.1, 97.0, 97.3],
    craftScore: {
      overall: 96.2,
      precision: 97.3,
      consistency: 96,
      edgeCases: 94,
      knowledgeSharing: 97,
    },
    craftHistory: [91.0, 92.5, 93.8, 94.2, 95.0, 95.5, 96.0, 96.2],
    edgeCasesFlagged: 18,
    insightsShared: 12,
    daysActiveThisCycle: 6,
    currentTeam: { name: 'Team Foley', id: 'foley' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 11', team: 'Team Foley', result: 'Cleared', craftScore: 95.5 },
      { name: 'Knowledge Sprint — Week 9', team: 'Team Foley', result: 'Cleared', craftScore: 96.0 },
      { name: 'Craft Sprint — Week 7', team: 'Team Ambience', result: 'Cleared', craftScore: 93.8 },
      { name: 'Craft Sprint — Week 4', team: 'Team Ambience', result: 'Fell Short', craftScore: 89.5 },
    ],
  },
  {
    id: 2,
    name: 'Tomás Reyes',
    domain: 'Video',
    badge: 'VFX Expert',
    quality: 95.1,
    jobs: 18,
    initials: 'TR',
    streak: 5,
    bio: 'VFX compositor and motion graphics artist. 6 years at Industrial Light & Magic working on feature films. Expert in temporal annotation and frame-level video analysis.',
    linkedin: 'https://linkedin.com/in/tomasreyes',
    website: 'https://tomasreyes.com',
    availability: 'Active',
    qualityHistory: [92.3, 93.1, 93.8, 94.2, 94.0, 94.7, 95.0, 95.1],
    craftScore: {
      overall: 93.8,
      precision: 95.1,
      consistency: 93,
      edgeCases: 91,
      knowledgeSharing: 96,
    },
    craftHistory: [89.0, 90.2, 91.0, 91.8, 92.5, 93.0, 93.5, 93.8],
    edgeCasesFlagged: 9,
    insightsShared: 14,
    daysActiveThisCycle: 5,
    currentTeam: { name: 'Team Foley', id: 'foley' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 11', team: 'Team Foley', result: 'In Progress', craftScore: 93.8 },
      { name: 'Calibration Sprint — Week 8', team: 'Team Parallax', result: 'Cleared', craftScore: 92.5 },
      { name: 'Craft Sprint — Week 6', team: 'Team Parallax', result: 'Fell Short', craftScore: 88.5 },
    ],
  },
  {
    id: 3,
    name: 'Priya Deshmukh',
    domain: 'Linguistics',
    badge: 'Multilingual Annotator',
    quality: 98.2,
    jobs: 31,
    initials: 'PD',
    streak: 12,
    bio: 'Computational linguist with a PhD from Stanford. Fluent in 5 languages. Specializing in semantic annotation, discourse analysis, and cross-lingual NLP evaluation.',
    linkedin: 'https://linkedin.com/in/priyadeshmukh',
    website: null,
    availability: 'Available',
    qualityHistory: [96.8, 97.1, 97.5, 97.3, 97.8, 98.0, 98.1, 98.2],
    craftScore: {
      overall: 97.5,
      precision: 98.2,
      consistency: 98,
      edgeCases: 96,
      knowledgeSharing: 97,
    },
    craftHistory: [94.0, 95.0, 95.8, 96.2, 96.8, 97.0, 97.3, 97.5],
    edgeCasesFlagged: 24,
    insightsShared: 8,
    daysActiveThisCycle: 7,
    currentTeam: { name: 'Team Syntax', id: 'syntax' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 10', team: 'Team Syntax', result: 'Cleared', craftScore: 97.0 },
      { name: 'Knowledge Sprint — Week 8', team: 'Team Syntax', result: 'Cleared', craftScore: 96.8 },
      { name: 'Craft Sprint — Week 5', team: 'Team Rosetta', result: 'Cleared', craftScore: 95.8 },
    ],
  },
  {
    id: 4,
    name: 'James Okonkwo',
    domain: 'Audio',
    badge: 'Sound Design Lead',
    quality: 96.8,
    jobs: 22,
    initials: 'JO',
    streak: 6,
    bio: 'Audio engineer and sound designer from Lagos. 10 years producing music and designing sound for interactive media. Expert in environmental audio classification and Foley annotation.',
    linkedin: 'https://linkedin.com/in/jamesokonkwo',
    website: 'https://jamesokonkwo.studio',
    availability: 'Active',
    qualityHistory: [93.5, 94.2, 95.0, 95.3, 95.8, 96.2, 96.5, 96.8],
    craftScore: {
      overall: 94.8,
      precision: 96.8,
      consistency: 94,
      edgeCases: 92,
      knowledgeSharing: 96,
    },
    craftHistory: [90.5, 91.2, 92.0, 92.8, 93.5, 94.0, 94.5, 94.8],
    edgeCasesFlagged: 14,
    insightsShared: 11,
    daysActiveThisCycle: 5,
    currentTeam: { name: 'Team Foley', id: 'foley' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 11', team: 'Team Foley', result: 'In Progress', craftScore: 94.5 },
      { name: 'Craft Sprint — Week 9', team: 'Team Foley', result: 'Cleared', craftScore: 94.0 },
      { name: 'Knowledge Sprint — Week 6', team: 'Team Waveform', result: 'Cleared', craftScore: 92.8 },
    ],
  },
  {
    id: 5,
    name: 'Ava Lindström',
    domain: 'Visual',
    badge: 'Computer Vision Specialist',
    quality: 94.9,
    jobs: 15,
    initials: 'AL',
    streak: 3,
    bio: 'Former research assistant at KTH Royal Institute of Technology. Background in computer vision and image segmentation. Focused on visual quality assessment and object detection annotation.',
    linkedin: 'https://linkedin.com/in/avalindstrom',
    website: null,
    availability: 'Active',
    qualityHistory: [91.2, 92.0, 92.8, 93.5, 93.9, 94.2, 94.6, 94.9],
    craftScore: {
      overall: 91.5,
      precision: 94.9,
      consistency: 88,
      edgeCases: 90,
      knowledgeSharing: 93,
    },
    craftHistory: [86.0, 87.5, 88.8, 89.5, 90.0, 90.8, 91.2, 91.5],
    edgeCasesFlagged: 7,
    insightsShared: 5,
    daysActiveThisCycle: 4,
    currentTeam: { name: 'Team Foley', id: 'foley' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 11', team: 'Team Foley', result: 'In Progress', craftScore: 91.2 },
      { name: 'Craft Sprint — Week 8', team: 'Team Pixel', result: 'Cleared', craftScore: 90.8 },
      { name: 'Craft Sprint — Week 5', team: 'Team Pixel', result: 'Fell Short', craftScore: 87.2 },
    ],
  },
  {
    id: 6,
    name: 'Kenji Watanabe',
    domain: 'Music',
    badge: 'Studio Engineer',
    quality: 97.5,
    jobs: 20,
    initials: 'KW',
    streak: 9,
    bio: 'Grammy-nominated studio engineer from Tokyo. 12 years at Sony Music Studios. Expert in music production annotation, instrument classification, and audio mastering quality evaluation.',
    linkedin: 'https://linkedin.com/in/kenjiwatanabe',
    website: 'https://kenjiwatanabe.jp',
    availability: 'Active',
    qualityHistory: [95.0, 95.5, 96.0, 96.3, 96.8, 97.0, 97.2, 97.5],
    craftScore: {
      overall: 95.8,
      precision: 97.5,
      consistency: 96,
      edgeCases: 93,
      knowledgeSharing: 96,
    },
    craftHistory: [91.5, 92.3, 93.0, 93.8, 94.5, 95.0, 95.5, 95.8],
    edgeCasesFlagged: 16,
    insightsShared: 10,
    daysActiveThisCycle: 6,
    currentTeam: { name: 'Team Foley', id: 'foley' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 11', team: 'Team Foley', result: 'In Progress', craftScore: 95.5 },
      { name: 'Knowledge Sprint — Week 9', team: 'Team Foley', result: 'Cleared', craftScore: 95.0 },
      { name: 'Craft Sprint — Week 6', team: 'Team Resonance', result: 'Cleared', craftScore: 93.8 },
    ],
  },
  // Team Waveform members
  {
    id: 7,
    name: 'Lena Park',
    domain: 'Audio',
    badge: 'Audio Analyst',
    quality: 93.5,
    jobs: 16,
    initials: 'LP',
    streak: 4,
    bio: 'Audio researcher specializing in speech recognition and acoustic scene classification. Background in signal processing from KAIST.',
    linkedin: 'https://linkedin.com/in/lenapark',
    website: null,
    availability: 'Active',
    qualityHistory: [90.0, 91.2, 91.8, 92.5, 93.0, 93.2, 93.4, 93.5],
    craftScore: { overall: 93.0, precision: 93.5, consistency: 93, edgeCases: 92, knowledgeSharing: 94 },
    craftHistory: [89.0, 90.0, 91.0, 91.5, 92.0, 92.5, 93.0, 93.0],
    edgeCasesFlagged: 11,
    insightsShared: 8,
    daysActiveThisCycle: 5,
    currentTeam: { name: 'Team Waveform', id: 'waveform' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', team: 'Team Waveform', result: 'In Progress', craftScore: 93.0 },
      { name: 'Craft Sprint — Week 10', team: 'Team Waveform', result: 'Cleared', craftScore: 92.5 },
    ],
  },
  {
    id: 8,
    name: 'Marcus Liu',
    domain: 'Audio',
    badge: 'Sound Classifier',
    quality: 92.8,
    jobs: 12,
    initials: 'ML',
    streak: 3,
    bio: 'Former Dolby engineer focused on spatial audio and immersive sound. Specializes in environmental audio classification.',
    linkedin: 'https://linkedin.com/in/marcusliu',
    website: null,
    availability: 'Active',
    qualityHistory: [88.5, 89.5, 90.2, 91.0, 91.5, 92.0, 92.5, 92.8],
    craftScore: { overall: 92.2, precision: 92.8, consistency: 91, edgeCases: 93, knowledgeSharing: 92 },
    craftHistory: [87.0, 88.5, 89.5, 90.0, 91.0, 91.5, 92.0, 92.2],
    edgeCasesFlagged: 13,
    insightsShared: 6,
    daysActiveThisCycle: 5,
    currentTeam: { name: 'Team Waveform', id: 'waveform' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', team: 'Team Waveform', result: 'In Progress', craftScore: 92.2 },
    ],
  },
  {
    id: 9,
    name: 'Sofia Herrera',
    domain: 'Audio',
    badge: 'Voice Annotation Lead',
    quality: 94.2,
    jobs: 19,
    initials: 'SH',
    streak: 6,
    bio: 'Voice acting coach turned audio annotator. Expert in speech emotion recognition, dialogue tagging, and vocal quality assessment.',
    linkedin: 'https://linkedin.com/in/sofiaherrera',
    website: 'https://sofiaherrera.audio',
    availability: 'Active',
    qualityHistory: [91.0, 92.0, 92.5, 93.0, 93.5, 93.8, 94.0, 94.2],
    craftScore: { overall: 94.0, precision: 94.2, consistency: 95, edgeCases: 92, knowledgeSharing: 95 },
    craftHistory: [90.0, 91.0, 92.0, 92.5, 93.0, 93.5, 94.0, 94.0],
    edgeCasesFlagged: 10,
    insightsShared: 14,
    daysActiveThisCycle: 6,
    currentTeam: { name: 'Team Waveform', id: 'waveform' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', team: 'Team Waveform', result: 'In Progress', craftScore: 94.0 },
      { name: 'Craft Sprint — Week 10', team: 'Team Waveform', result: 'Cleared', craftScore: 93.5 },
    ],
  },
  {
    id: 10,
    name: 'Daniel Kim',
    domain: 'Audio',
    badge: 'Music Production Analyst',
    quality: 93.0,
    jobs: 14,
    initials: 'DK',
    streak: 4,
    bio: 'Music producer and mix engineer from Seoul. 7 years in K-pop production. Specializes in instrument separation and mixing quality annotation.',
    linkedin: 'https://linkedin.com/in/danielkim',
    website: null,
    availability: 'Active',
    qualityHistory: [89.0, 90.0, 91.0, 91.5, 92.0, 92.5, 92.8, 93.0],
    craftScore: { overall: 92.5, precision: 93.0, consistency: 92, edgeCases: 91, knowledgeSharing: 94 },
    craftHistory: [88.0, 89.0, 90.0, 90.5, 91.5, 92.0, 92.2, 92.5],
    edgeCasesFlagged: 8,
    insightsShared: 9,
    daysActiveThisCycle: 5,
    currentTeam: { name: 'Team Waveform', id: 'waveform' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', team: 'Team Waveform', result: 'In Progress', craftScore: 92.5 },
    ],
  },
  {
    id: 11,
    name: 'Rachel Torres',
    domain: 'Audio',
    badge: 'Acoustic Specialist',
    quality: 93.8,
    jobs: 17,
    initials: 'RT',
    streak: 5,
    bio: 'Acoustics engineer with a focus on noise analysis and environmental sound mapping. PhD candidate at Georgia Tech.',
    linkedin: 'https://linkedin.com/in/racheltorres',
    website: null,
    availability: 'Active',
    qualityHistory: [90.5, 91.2, 92.0, 92.5, 93.0, 93.2, 93.5, 93.8],
    craftScore: { overall: 93.5, precision: 93.8, consistency: 94, edgeCases: 92, knowledgeSharing: 94 },
    craftHistory: [89.5, 90.5, 91.0, 92.0, 92.5, 93.0, 93.2, 93.5],
    edgeCasesFlagged: 12,
    insightsShared: 7,
    daysActiveThisCycle: 6,
    currentTeam: { name: 'Team Waveform', id: 'waveform' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', team: 'Team Waveform', result: 'In Progress', craftScore: 93.5 },
      { name: 'Calibration Sprint — Week 6', team: 'Team Waveform', result: 'Cleared', craftScore: 92.5 },
    ],
  },
  // Team Syntax members (Priya is id:3, already exists)
  {
    id: 12,
    name: 'Yuki Tanaka',
    domain: 'Linguistics',
    badge: 'NLP Specialist',
    quality: 96.5,
    jobs: 22,
    initials: 'YT',
    streak: 7,
    bio: 'Computational linguist from Tokyo. Expert in Japanese-English cross-lingual annotation, semantic parsing, and discourse analysis.',
    linkedin: 'https://linkedin.com/in/yukitanaka',
    website: null,
    availability: 'Active',
    qualityHistory: [93.0, 94.0, 94.5, 95.0, 95.5, 96.0, 96.2, 96.5],
    craftScore: { overall: 96.0, precision: 96.5, consistency: 96, edgeCases: 95, knowledgeSharing: 97 },
    craftHistory: [92.0, 93.0, 94.0, 94.5, 95.0, 95.5, 96.0, 96.0],
    edgeCasesFlagged: 20,
    insightsShared: 11,
    daysActiveThisCycle: 7,
    currentTeam: { name: 'Team Syntax', id: 'syntax' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', team: 'Team Syntax', result: 'In Progress', craftScore: 96.0 },
      { name: 'Calibration Sprint — Week 11', team: 'Team Syntax', result: 'Cleared', craftScore: 95.5 },
    ],
  },
  {
    id: 13,
    name: 'Elena Vasquez',
    domain: 'Linguistics',
    badge: 'Multilingual Analyst',
    quality: 95.8,
    jobs: 20,
    initials: 'EV',
    streak: 6,
    bio: 'Translator and linguist fluent in Spanish, Portuguese, French, and English. Specializing in sentiment annotation and cultural context analysis.',
    linkedin: 'https://linkedin.com/in/elenavasquez',
    website: null,
    availability: 'Active',
    qualityHistory: [92.0, 93.0, 93.5, 94.0, 94.5, 95.0, 95.5, 95.8],
    craftScore: { overall: 95.5, precision: 95.8, consistency: 96, edgeCases: 94, knowledgeSharing: 96 },
    craftHistory: [91.0, 92.0, 93.0, 93.5, 94.0, 94.5, 95.0, 95.5],
    edgeCasesFlagged: 16,
    insightsShared: 9,
    daysActiveThisCycle: 6,
    currentTeam: { name: 'Team Syntax', id: 'syntax' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', team: 'Team Syntax', result: 'In Progress', craftScore: 95.5 },
    ],
  },
  {
    id: 14,
    name: 'Omar Hassan',
    domain: 'Linguistics',
    badge: 'Arabic Language Expert',
    quality: 97.0,
    jobs: 25,
    initials: 'OH',
    streak: 9,
    bio: 'Arabic linguist and NLP researcher. Former UN translator. Expert in Arabic dialectal variation and morphological annotation.',
    linkedin: 'https://linkedin.com/in/omarhassan',
    website: null,
    availability: 'Active',
    qualityHistory: [94.0, 95.0, 95.5, 96.0, 96.5, 96.8, 97.0, 97.0],
    craftScore: { overall: 96.8, precision: 97.0, consistency: 97, edgeCases: 96, knowledgeSharing: 97 },
    craftHistory: [93.0, 94.0, 94.5, 95.5, 96.0, 96.5, 96.8, 96.8],
    edgeCasesFlagged: 22,
    insightsShared: 13,
    daysActiveThisCycle: 7,
    currentTeam: { name: 'Team Syntax', id: 'syntax' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', team: 'Team Syntax', result: 'In Progress', craftScore: 96.8 },
      { name: 'Knowledge Sprint — Week 7', team: 'Team Syntax', result: 'Cleared', craftScore: 96.0 },
    ],
  },
  {
    id: 15,
    name: 'Chiara Russo',
    domain: 'Linguistics',
    badge: 'Romance Languages Lead',
    quality: 96.2,
    jobs: 18,
    initials: 'CR',
    streak: 5,
    bio: 'Italian linguist specializing in Romance language annotation. Background in comparative syntax at University of Bologna.',
    linkedin: 'https://linkedin.com/in/chiararusso',
    website: null,
    availability: 'Away',
    qualityHistory: [93.0, 93.5, 94.0, 94.5, 95.0, 95.5, 96.0, 96.2],
    craftScore: { overall: 95.8, precision: 96.2, consistency: 95, edgeCases: 95, knowledgeSharing: 97 },
    craftHistory: [92.0, 93.0, 93.5, 94.0, 94.5, 95.0, 95.5, 95.8],
    edgeCasesFlagged: 14,
    insightsShared: 10,
    daysActiveThisCycle: 4,
    currentTeam: { name: 'Team Syntax', id: 'syntax' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', team: 'Team Syntax', result: 'In Progress', craftScore: 95.8 },
    ],
  },
  {
    id: 16,
    name: 'Amir Patel',
    domain: 'Linguistics',
    badge: 'Hindi-Urdu Specialist',
    quality: 95.5,
    jobs: 16,
    initials: 'AP',
    streak: 4,
    bio: 'Sociolinguist focused on Hindi-Urdu code-switching and South Asian language annotation. Research associate at JNU Delhi.',
    linkedin: 'https://linkedin.com/in/amirpatel',
    website: null,
    availability: 'Active',
    qualityHistory: [91.5, 92.5, 93.0, 93.5, 94.0, 94.5, 95.0, 95.5],
    craftScore: { overall: 95.0, precision: 95.5, consistency: 95, edgeCases: 94, knowledgeSharing: 96 },
    craftHistory: [90.5, 91.5, 92.5, 93.0, 93.5, 94.0, 94.5, 95.0],
    edgeCasesFlagged: 15,
    insightsShared: 7,
    daysActiveThisCycle: 5,
    currentTeam: { name: 'Team Syntax', id: 'syntax' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', team: 'Team Syntax', result: 'In Progress', craftScore: 95.0 },
    ],
  },
  // Team Parallax members (Tomás is id:2)
  {
    id: 17,
    name: 'Nadia Volkov',
    domain: 'Video',
    badge: 'Motion Analysis Expert',
    quality: 93.5,
    jobs: 14,
    initials: 'NV',
    streak: 3,
    bio: 'Former motion capture specialist at Weta Digital. Expert in temporal video annotation and human pose estimation.',
    linkedin: 'https://linkedin.com/in/nadiavolkov',
    website: null,
    availability: 'Active',
    qualityHistory: [90.0, 91.0, 91.5, 92.0, 92.5, 93.0, 93.2, 93.5],
    craftScore: { overall: 92.8, precision: 93.5, consistency: 92, edgeCases: 91, knowledgeSharing: 95 },
    craftHistory: [88.0, 89.5, 90.0, 91.0, 91.5, 92.0, 92.5, 92.8],
    edgeCasesFlagged: 9,
    insightsShared: 8,
    daysActiveThisCycle: 5,
    currentTeam: { name: 'Team Parallax', id: 'parallax' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', team: 'Team Parallax', result: 'In Progress', craftScore: 92.8 },
    ],
  },
  {
    id: 18,
    name: 'Chris Nakamura',
    domain: 'Video',
    badge: 'Scene Classification Analyst',
    quality: 91.0,
    jobs: 10,
    initials: 'CN',
    streak: 2,
    bio: 'Film editor and colorist turned video annotator. Expertise in scene transition detection and cinematic quality assessment.',
    linkedin: 'https://linkedin.com/in/chrisnakamura',
    website: null,
    availability: 'Active',
    qualityHistory: [87.0, 88.0, 88.5, 89.5, 90.0, 90.5, 90.8, 91.0],
    craftScore: { overall: 90.2, precision: 91.0, consistency: 89, edgeCases: 90, knowledgeSharing: 91 },
    craftHistory: [85.0, 86.5, 87.5, 88.0, 89.0, 89.5, 90.0, 90.2],
    edgeCasesFlagged: 6,
    insightsShared: 5,
    daysActiveThisCycle: 4,
    currentTeam: { name: 'Team Parallax', id: 'parallax' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', team: 'Team Parallax', result: 'In Progress', craftScore: 90.2 },
      { name: 'Craft Sprint — Week 10', team: 'Team Parallax', result: 'Fell Short', craftScore: 86.8 },
    ],
  },
  {
    id: 19,
    name: 'Fatima Al-Rashid',
    domain: 'Video',
    badge: 'Temporal Annotation Specialist',
    quality: 92.5,
    jobs: 13,
    initials: 'FA',
    streak: 4,
    bio: 'Video analyst with a background in broadcast journalism. Expert in event detection, temporal segmentation, and action recognition annotation.',
    linkedin: 'https://linkedin.com/in/fatimaalrashid',
    website: null,
    availability: 'Active',
    qualityHistory: [89.0, 90.0, 90.5, 91.0, 91.5, 92.0, 92.2, 92.5],
    craftScore: { overall: 91.8, precision: 92.5, consistency: 91, edgeCases: 91, knowledgeSharing: 93 },
    craftHistory: [87.0, 88.5, 89.0, 90.0, 90.5, 91.0, 91.5, 91.8],
    edgeCasesFlagged: 10,
    insightsShared: 6,
    daysActiveThisCycle: 5,
    currentTeam: { name: 'Team Parallax', id: 'parallax' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', team: 'Team Parallax', result: 'In Progress', craftScore: 91.8 },
    ],
  },
  {
    id: 20,
    name: 'Leo Brennan',
    domain: 'Video',
    badge: 'Video QA Analyst',
    quality: 91.8,
    jobs: 11,
    initials: 'LB',
    streak: 3,
    bio: 'Documentary filmmaker and video editor. Focused on object tracking annotation and visual continuity assessment.',
    linkedin: 'https://linkedin.com/in/leobrennan',
    website: null,
    availability: 'Active',
    qualityHistory: [88.0, 89.0, 89.5, 90.0, 90.5, 91.0, 91.5, 91.8],
    craftScore: { overall: 91.0, precision: 91.8, consistency: 90, edgeCases: 90, knowledgeSharing: 92 },
    craftHistory: [86.0, 87.5, 88.0, 89.0, 89.5, 90.0, 90.5, 91.0],
    edgeCasesFlagged: 7,
    insightsShared: 5,
    daysActiveThisCycle: 4,
    currentTeam: { name: 'Team Parallax', id: 'parallax' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', team: 'Team Parallax', result: 'In Progress', craftScore: 91.0 },
    ],
  },
  // Team Pixel members (Ava is id:5)
  {
    id: 21,
    name: 'Jamal Wright',
    domain: 'Visual',
    badge: 'Image Segmentation Lead',
    quality: 94.5,
    jobs: 17,
    initials: 'JW',
    streak: 5,
    bio: 'Computer vision researcher from MIT. Specializes in semantic segmentation, instance detection, and visual quality assessment.',
    linkedin: 'https://linkedin.com/in/jamalwright',
    website: null,
    availability: 'Active',
    qualityHistory: [91.0, 92.0, 92.5, 93.0, 93.5, 94.0, 94.2, 94.5],
    craftScore: { overall: 94.0, precision: 94.5, consistency: 94, edgeCases: 93, knowledgeSharing: 95 },
    craftHistory: [90.0, 91.0, 91.5, 92.5, 93.0, 93.5, 93.8, 94.0],
    edgeCasesFlagged: 15,
    insightsShared: 9,
    daysActiveThisCycle: 6,
    currentTeam: { name: 'Team Pixel', id: 'pixel' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', team: 'Team Pixel', result: 'In Progress', craftScore: 94.0 },
    ],
  },
  {
    id: 22,
    name: 'Mina Chen',
    domain: 'Visual',
    badge: 'Object Detection Analyst',
    quality: 93.8,
    jobs: 13,
    initials: 'MN',
    streak: 4,
    bio: 'UI designer turned visual annotator. Expert in bounding box precision, object classification, and visual relationship annotation.',
    linkedin: 'https://linkedin.com/in/minachen',
    website: null,
    availability: 'Active',
    qualityHistory: [90.0, 91.0, 91.5, 92.0, 92.5, 93.0, 93.5, 93.8],
    craftScore: { overall: 93.2, precision: 93.8, consistency: 93, edgeCases: 92, knowledgeSharing: 94 },
    craftHistory: [89.0, 90.0, 90.5, 91.5, 92.0, 92.5, 93.0, 93.2],
    edgeCasesFlagged: 11,
    insightsShared: 7,
    daysActiveThisCycle: 5,
    currentTeam: { name: 'Team Pixel', id: 'pixel' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', team: 'Team Pixel', result: 'In Progress', craftScore: 93.2 },
    ],
  },
  {
    id: 23,
    name: 'Sam Oduya',
    domain: 'Visual',
    badge: 'Depth Estimation Specialist',
    quality: 94.0,
    jobs: 15,
    initials: 'SO',
    streak: 5,
    bio: 'Robotics engineer specializing in depth perception and 3D scene understanding. Expert in point cloud annotation and stereo vision.',
    linkedin: 'https://linkedin.com/in/samoduya',
    website: null,
    availability: 'Active',
    qualityHistory: [90.5, 91.5, 92.0, 92.5, 93.0, 93.5, 93.8, 94.0],
    craftScore: { overall: 93.5, precision: 94.0, consistency: 93, edgeCases: 93, knowledgeSharing: 94 },
    craftHistory: [89.5, 90.5, 91.0, 92.0, 92.5, 93.0, 93.2, 93.5],
    edgeCasesFlagged: 13,
    insightsShared: 8,
    daysActiveThisCycle: 6,
    currentTeam: { name: 'Team Pixel', id: 'pixel' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', team: 'Team Pixel', result: 'In Progress', craftScore: 93.5 },
    ],
  },
  // Team Resonance members (Kenji is id:6)
  {
    id: 24,
    name: 'Aria Johansson',
    domain: 'Music',
    badge: 'Vocal Analysis Expert',
    quality: 95.8,
    jobs: 18,
    initials: 'AJ',
    streak: 6,
    bio: 'Opera singer and vocal coach from Stockholm. Expert in vocal quality annotation, pitch analysis, and singing voice detection.',
    linkedin: 'https://linkedin.com/in/ariajohansson',
    website: 'https://ariajohansson.music',
    availability: 'Active',
    qualityHistory: [92.0, 93.0, 93.5, 94.0, 94.5, 95.0, 95.5, 95.8],
    craftScore: { overall: 95.5, precision: 95.8, consistency: 96, edgeCases: 94, knowledgeSharing: 96 },
    craftHistory: [91.0, 92.0, 92.5, 93.5, 94.0, 94.5, 95.0, 95.5],
    edgeCasesFlagged: 14,
    insightsShared: 11,
    daysActiveThisCycle: 6,
    currentTeam: { name: 'Team Resonance', id: 'resonance' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', team: 'Team Resonance', result: 'In Progress', craftScore: 95.5 },
      { name: 'Calibration Sprint — Week 11', team: 'Team Resonance', result: 'Cleared', craftScore: 95.0 },
    ],
  },
  {
    id: 25,
    name: 'Davi Santos',
    domain: 'Music',
    badge: 'Rhythm Analysis Specialist',
    quality: 94.5,
    jobs: 15,
    initials: 'DS',
    streak: 5,
    bio: 'Percussionist and music producer from São Paulo. Expert in beat tracking, rhythm annotation, and Brazilian music genre classification.',
    linkedin: 'https://linkedin.com/in/davisantos',
    website: null,
    availability: 'Active',
    qualityHistory: [91.0, 92.0, 92.5, 93.0, 93.5, 94.0, 94.2, 94.5],
    craftScore: { overall: 94.0, precision: 94.5, consistency: 94, edgeCases: 93, knowledgeSharing: 95 },
    craftHistory: [90.0, 91.0, 91.5, 92.5, 93.0, 93.5, 93.8, 94.0],
    edgeCasesFlagged: 10,
    insightsShared: 9,
    daysActiveThisCycle: 5,
    currentTeam: { name: 'Team Resonance', id: 'resonance' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', team: 'Team Resonance', result: 'In Progress', craftScore: 94.0 },
    ],
  },
  {
    id: 26,
    name: 'Nina Kovalenko',
    domain: 'Music',
    badge: 'Classical Music Annotator',
    quality: 96.0,
    jobs: 19,
    initials: 'NK',
    streak: 7,
    bio: 'Concert pianist and musicologist from Moscow Conservatory. Expert in classical music structure annotation, key detection, and harmonic analysis.',
    linkedin: 'https://linkedin.com/in/ninakovalenko',
    website: null,
    availability: 'Active',
    qualityHistory: [93.0, 93.5, 94.0, 94.5, 95.0, 95.5, 95.8, 96.0],
    craftScore: { overall: 95.5, precision: 96.0, consistency: 96, edgeCases: 94, knowledgeSharing: 96 },
    craftHistory: [91.5, 92.5, 93.0, 93.5, 94.5, 95.0, 95.2, 95.5],
    edgeCasesFlagged: 17,
    insightsShared: 10,
    daysActiveThisCycle: 6,
    currentTeam: { name: 'Team Resonance', id: 'resonance' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', team: 'Team Resonance', result: 'In Progress', craftScore: 95.5 },
      { name: 'Craft Sprint — Week 10', team: 'Team Resonance', result: 'Cleared', craftScore: 95.0 },
    ],
  },
  {
    id: 27,
    name: 'Theo Abrams',
    domain: 'Music',
    badge: 'Audio Engineering Analyst',
    quality: 95.0,
    jobs: 16,
    initials: 'TA',
    streak: 5,
    bio: 'Audio engineer from Nashville. 8 years mixing and mastering for indie labels. Expert in production quality annotation and mix analysis.',
    linkedin: 'https://linkedin.com/in/theoabrams',
    website: null,
    availability: 'Active',
    qualityHistory: [91.5, 92.5, 93.0, 93.5, 94.0, 94.5, 94.8, 95.0],
    craftScore: { overall: 94.5, precision: 95.0, consistency: 94, edgeCases: 93, knowledgeSharing: 96 },
    craftHistory: [90.0, 91.0, 91.5, 92.5, 93.0, 93.5, 94.0, 94.5],
    edgeCasesFlagged: 12,
    insightsShared: 8,
    daysActiveThisCycle: 5,
    currentTeam: { name: 'Team Resonance', id: 'resonance' },
    sprintHistory: [
      { name: 'Craft Sprint — Week 12', team: 'Team Resonance', result: 'In Progress', craftScore: 94.5 },
    ],
  },
];

export const getUserById = (id) => users.find((u) => u.id === Number(id));
